/** Drops the DS's tight-line-height offset from a Display figure spaced here. */
export const FLUSH_DISPLAY = {
  paddingTop: "$sp0",
  marginTop: "$sp0",
  marginBottom: "$sp0",
} as const;

export const PAGE_GUTTER = { paddingHorizontal: "$sp2" } as const;
